import {HStack, Image, Link} from "@hosttools/frontend/components";
import {memo} from "react";

import AppStore2 from "@/admin/img/app-store-2.svg";
import GooglePlay2 from "@/admin/img/google-play-2.svg";
import Text from "@/client/components/Text";

const imageAppStore = {uri: AppStore2};
const imageGooglePlay = {uri: GooglePlay2};

const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <HStack className="min-h-[36px] px-2 lg:px-7 justify-between items-center border-t border-blueGray-200 border-solid py-2 mt-auto">
            <HStack className="hidden lg:flex" space="sm">
                <Link href="https://apps.apple.com/app/host-tools/id1576749305" type="external">
                    <Image alt="App Store" className="h-[18px] w-[60px]" source={imageAppStore} />
                </Link>
                <Link
                    href="https://play.google.com/store/apps/details?id=com.hosttools.hosttools"
                    type="external"
                >
                    <Image
                        alt="Google Play Store"
                        className="h-[18px] w-[60px]"
                        source={imageGooglePlay}
                    />
                </Link>
            </HStack>
            <Text color="blueGray.800" variant="2xs">
                &copy;{` ${year} Host Tools`}
            </Text>
            <HStack space="sm">
                <Link href="https://hosttools.com/PrivacyPolicy" type="external">
                    <Text color="blueGray.800" variant="2xs">
                        Privacy Policy
                    </Text>
                </Link>
                <Link href="https://hosttools.com/TermsOfUse" type="external">
                    <Text color="blueGray.800" variant="2xs">
                        Terms Of Use
                    </Text>
                </Link>
            </HStack>
        </HStack>
    );
};

export default memo(Footer);
